/**
 * Lazy, single-flight loader for the UI/ClassMap bonds (bonds/ui.ts).
 *
 * The ClassMap bonds are deliberately kept out of the eager landing entry (see
 * bonds/ui.ts) — routes load them via App.tsx's `lazyPage`, and App-level
 * ambient surfaces that can render on ANY route (HealthBanner,
 * NotificationBanner) load them on demand via the `useUiProviders` hook the
 * moment they actually have something to show. Both paths funnel through this
 * one promise so setup runs exactly once.
 */

import { holdWhileReloading } from '../lib/chunk-reload.js'

let uiReady: Promise<void> | undefined

/**
 * Wire the UI/ClassMap bonds, loading their chunk on first call. Subsequent
 * calls return the same promise. While a stale-chunk reload is under way the
 * chunk resolves to `undefined`; the promise then waits for the reload rather
 * than rejecting (lib/chunk-reload.ts).
 */
export function ensureUiProviders(): Promise<void> {
  return (uiReady ??= import('./ui.js')
    .then((m) => m.setupUiProviders())
    .catch(holdWhileReloading<void>))
}
